import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = false;

const isLoading = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [actionTypes.START_SECTION_DND]: isLoading,
  [actionTypes.END_SECTION_DND]: isEnded,
});
